import { Suspense, lazy, useState } from "react";

const FormFlows = lazy(() => import("@Components/CreateInspectionAndProgress/formFlow"));
const FormFlowCreationNew = lazy(() => import("../../CreateInspectionAndProgress/formFlowCreationNew"));

function FormflowsWrapper({ spaceId, projectId }) {
  const [formFlowId, setFormFlowId] = useState(null);

  const handleBackClick = () => {
    setFormFlowId(null);
  };

  return (
    <>
      {!formFlowId ? (
        <Suspense>
          <FormFlows setFormFlowId={setFormFlowId} spaceId={spaceId} projectId={projectId} />
        </Suspense>
      ) : (
        <Suspense>
          <FormFlowCreationNew
            handleBackClick={handleBackClick}
            formFlowId={formFlowId}
            source="SPACE_SETTINGS"
            spaceId={spaceId}
            projectId={projectId}
          />
        </Suspense>
      )}
    </>
  );
}

export default FormflowsWrapper;
